import { render } from "./qualityInspection2.vue?vue&type=template&id=493ab000&scoped=true"
import script from "./qualityInspection2.vue?vue&type=script&lang=js"
export * from "./qualityInspection2.vue?vue&type=script&lang=js"

import "./qualityInspection2.vue?vue&type=style&index=0&id=493ab000&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-493ab000"

export default script